import { NoSsr } from '@mui/base';
import { DateTime } from 'luxon';
import React from 'react';
import { formatDate } from './format-date';

export const DateFormat = ({
  children = '',
  format = DateTime.DATE_SHORT,
  locale,
  readable,
  relative,
  suffix = '',
  inline = false,
}: {
  children?: string | undefined | null | DateTime | Date;
  format?: Intl.DateTimeFormatOptions;
  locale: string;
  readable?: boolean;
  relative?: boolean;
  suffix?: string;
  inline?: boolean;
}) => {
  const formatted = React.useMemo(
    () => formatDate(children, { format, locale, readable, relative, suffix }),
    [children, format, locale, readable, relative, suffix],
  );

  if (!formatted) {
    return null;
  }

  const content = <span style={{ whiteSpace: 'nowrap' }}>{formatted}</span>;

  return <NoSsr>{inline ? formatted : content}</NoSsr>;
};
